import {FC, useEffect, useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {setAuth, getAuth} from '../core/AuthHelpers'

const ImpersonateCallback: FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const processImpersonation = async () => {
      try {
        const token = searchParams.get('token')
        
        if (!token) {
          setError('Token não encontrado na URL')
          setTimeout(() => navigate('/auth/login'), 2000)
          return
        }

        // Save the token to localStorage
        const auth = {
          api_token: token,
        }
        setAuth(auth)
        
        // Verify the token was saved
        const savedAuth = getAuth()
        
        if (!savedAuth || savedAuth.api_token !== token) {
          setError('Erro ao salvar token')
          setTimeout(() => navigate('/auth/login'), 2000)
          return
        }

        // Wait for localStorage to be fully persisted
        await new Promise(resolve => setTimeout(resolve, 500))
        
        // Force a full page reload to reinitialize auth
        window.location.href = '/dashboard'
        
      } catch (err) {
        console.error('Error during impersonation callback:', err)
        setError('Erro ao processar simulação')
        setTimeout(() => navigate('/auth/login'), 2000)
      }
    }

    processImpersonation()
  }, [searchParams, navigate])

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column flex-center text-center p-10'>
          <div className='card card-flush w-lg-650px py-5'>
            <div className='card-body py-15 py-lg-20'>
              {!error ? (
                <>
                  <div className='mb-7'>
                    <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
                  </div>
                  <h1 className='fw-bolder text-gray-900 mb-5'>Iniciando simulação...</h1>
                  <div className='fw-semibold fs-6 text-gray-500 mb-7'>
                    Por favor, aguarde enquanto configuramos seu acesso.
                  </div>
                </>
              ) : (
                <>
                  <div className='mb-7'>
                    <i className='bi bi-x-circle-fill text-danger' style={{fontSize: '4rem'}}></i>
                  </div>
                  <h1 className='fw-bolder text-danger mb-5'>Erro na Simulação</h1>
                  <div className='fw-semibold fs-6 text-gray-500 mb-7'>
                    {error}
                  </div>
                  <div className='text-muted'>
                    Redirecionando para o login...
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ImpersonateCallback}

